module.exports = __webpack_public_path__ + "img/icon_--_follow_up.1f09326e.png";